<template>
  <div v-if="isVisible && !isStripeCustomer">
    <template>
      <base-modal v-if="!pricesLoaded">
        <Spinner />
      </base-modal>

      <base-modal
        v-else-if="
          step === 0 &&
          (blackFridayCustomerStatus === 'basic' ||
            (blackFridayCustomerStatus === 'standard' && isUserMonthly))
        "
        @close="close"
      >
        <div
          class="relative flex flex-col gap-10 bg-ds-background p-10"
          :style="{
            width: isMobile ? '350px' : '529px',
          }"
        >
          <button class="absolute right-3 top-3" @click="close">
            <inline-svg src="/img/icons/close.svg" />
          </button>

          <h1 class="text-center">Special Black Friday offer</h1>

          <div class="space-y-6">
            <div
              class="border space-y-4 rounded-lg border-ds-outline-primary bg-ds-foreground px-8 py-5"
            >
              <div>
                <p class="text-base font-semi-medium capitalize">PROMO 1</p>
                <p>Upgrade to Starter Yearly 20% off</p>
                <p
                  :class="[
                    'font-bold text-ds-button-primary-background',
                    isMobile ? 'text-xl' : 'text-3xl',
                  ]"
                >
                  PRICE:
                  <span class="text-ds-text-secondary-tertiary line-through"
                    >{{ standardYearly.net ? standardYearly.net.toFixed(0) : 250
                    }}{{ standardYearly.currency || '$' }}</span
                  >
                  {{ standardYearly.newPrice ? standardYearly.newPrice.toFixed(0) : 200
                  }}{{ standardYearly.currency || '$' }}
                </p>
              </div>
              <new-button @click="showNextStep('standard')" class="w-full">
                Get Starter Yearly
              </new-button>
            </div>

            <div
              class="border space-y-4 rounded-lg border-ds-outline-primary bg-ds-foreground px-8 py-5"
            >
              <div>
                <p class="text-base font-semi-medium capitalize">PROMO 2</p>
                <p>
                  Upgrade to Creator Yearly 40% off + Free access to v2 + Creator Courses + Road to
                  Freedom
                </p>
                <p
                  :class="[
                    'font-bold text-ds-button-primary-background',
                    isMobile ? 'text-xl' : 'text-3xl',
                  ]"
                >
                  PRICE:
                  <span class="text-ds-text-secondary-tertiary line-through"
                    >{{ premiumYearly.net ? premiumYearly.net.toFixed(0) : 590
                    }}{{ premiumYearly.currency || '$' }}</span
                  >
                  {{ premiumYearly.newPrice ? premiumYearly.newPrice.toFixed(0) : 354
                  }}{{ premiumYearly.currency || '$' }}
                </p>
              </div>
              <new-button @click="showNextStep('premium')" class="w-full">
                Get Creator Yearly
              </new-button>
            </div>
          </div>
        </div>
      </base-modal>

      <base-modal v-else-if="step === 0" @close="close">
        <div
          class="relative flex flex-col gap-10 bg-ds-background p-10"
          :style="{
            width: isMobile ? '350px' : '529px',
          }"
        >
          <button class="absolute right-3 top-3" @click="close">
            <inline-svg src="/img/icons/close.svg" />
          </button>

          <h1 class="text-center">Special Black Friday offer</h1>

          <div
            class="border space-y-6 rounded-lg border-ds-outline-primary bg-ds-foreground px-8 py-5"
          >
            <div>
              <span class="flex items-center justify-between">
                <p class="text-base font-semi-medium capitalize">{{ computedPlanName }} Yearly</p>
                <span
                  v-if="this.blackFridayCustomerStatus !== 'none'"
                  class="rounded-full bg-black px-3 py-1 text-xl font-bold text-white"
                >
                  {{ discountPercentage }}% off
                </span>
                <span v-else class="rounded-full bg-black px-3 py-1 text-xl font-bold text-white">
                  Offer ends soon
                </span>
              </span>
              <p class="text-3xl font-bold text-ds-button-primary-background">{{ priceLabel }}</p>
              <p class="text-base font-semi-medium text-secondary">{{ VATPrice }} VAT</p>
            </div>
            <div class="w-full space-y-3 text-base">
              <div class="flex w-full items-center gap-3">
                <inline-svg class="h-5 w-5 stroke-blues-50" src="/img/icons/schedule-icon.svg" />
                <p v-if="scheduleLimit === Infinity">Unlimited Scheduling</p>
                <p v-else>Schedule up to {{ scheduleLimit }} month</p>
              </div>

              <div class="flex w-full items-center gap-3">
                <inline-svg
                  class="h-5 w-5 fill-transparent stroke-blues-50"
                  src="/img/icons/new/avatar-outline.svg"
                />
                <span class="flex items-center gap-1">
                  <p>{{ connectedAccountsLimit }}</p>
                  <inline-svg
                    class="h-5 w-5 stroke-blues-50"
                    src="/img/icons/new/socials/twitter.svg"
                  />
                  <p>accounts</p>
                </span>
              </div>

              <template v-if="['standard', 'premium'].includes(blackFridayCustomerStatus)">
                <div class="flex w-full gap-3">
                  <inline-svg class="h-5 w-5 text-blues-50" src="/img/icons/new/autoplug.svg" />
                  <p>Autoplugs</p>
                </div>
                <div class="flex w-full gap-3">
                  <inline-svg
                    class="h-5 w-5 fill-transparent stroke-blues-50"
                    src="/img/icons/new/folder-plus-outline.svg"
                  />
                  <p class="flex-1">Viral thread hooks and tweet templates</p>
                </div>
              </template>

              <div
                v-if="['standard', 'premium'].includes(blackFridayCustomerStatus)"
                class="flex w-full items-center gap-3"
              >
                <inline-svg class="h-5 w-5 stroke-blues-50" src="/img/icons/messages.svg" />
                <span class="flex items-center gap-1">
                  <p>{{ autoDmsLimit }}</p>
                  <inline-svg
                    class="h-5 w-5 stroke-blues-50"
                    src="/img/icons/new/socials/twitter.svg"
                  />
                  <p>Auto-DMs per day</p>
                </span>
              </div>

              <div
                v-if="['standard', 'premium'].includes(blackFridayCustomerStatus)"
                class="flex w-full gap-3"
              >
                <inline-svg class="h-5 w-5 stroke-blues-50" src="/img/icons/new/siren.svg" />
                <p class="flex-1">
                  Increase engagement by watching up to {{ engagementLimit.users }} users &
                  {{ engagementLimit.keywords }} keywords
                </p>
              </div>

              <div
                v-if="['standard', 'premium'].includes(blackFridayCustomerStatus)"
                class="flex w-full items-center gap-3"
              >
                <inline-svg
                  class="h-5 w-5 stroke-blues-50"
                  src="/img/icons/new/gumroad-sales-outline.svg"
                />
                <p class="flex-1">Automated Gumroad sales</p>
              </div>

              <div class="flex w-full items-center gap-3">
                <template
                  v-if="
                    ['standard', 'basic', 'none', 'premium'].includes(blackFridayCustomerStatus)
                  "
                >
                  <inline-svg
                    class="h-5 w-5 stroke-blues-50"
                    src="/img/icons/new/chat-support-outline.svg"
                  />
                  <p class="flex-1">Email & Chat support</p>
                </template>
              </div>
            </div>
          </div>

          <div class="space-y-3">
            <span class="flex items-center gap-3">
              <new-button @click="close" class="px-6" type="secondary">Go back</new-button>
              <new-button @click="showNextStep(planNameForCheckout)" class="flex-1">
                Take this offer
              </new-button>
            </span>

            <p class="text-center text-sm font-semi-medium text-ds-text-secondary-tertiary">
              The new billing cycle will take effect immediately.
            </p>
          </div>
        </div>
      </base-modal>

      <base-modal v-else-if="step === 1" @close="close">
        <div
          class="relative space-y-6 px-10 py-12"
          :style="{
            width: isMobile ? '350px' : '500px',
          }"
        >
          <button class="absolute right-7 top-9" @click="close">
            <inline-svg src="/img/icons/close.svg" />
          </button>

          <inline-svg class="icon" src="/img/icons/wallet.svg" />
          <h2 v-if="parentUserProfile.subscriptionId">We have all your details!</h2>
          <h2 v-else>This will open the checkout</h2>

          <div class="flex flex-col items-center space-y-6">
            <new-button
              :disabled="isUpgrading"
              @click="
                parentUserProfile.subscriptionId &&
                parentUserProfile.subscriptionStatus === 'active'
                  ? upgradeUserToYearly()
                  : checkout(planName)
              "
              class="w-full py-4"
            >
              Grab
              {{ this.planNameToDisplay }}
              Yearly Deal
            </new-button>
          </div>
        </div>
      </base-modal>
    </template>
  </div>
</template>

<script>
  import SwalModalMixin from '@/views/Mixins/SwalModalMixin.vue';
  import { mapGetters, mapState } from 'vuex';
  import { v4 as publicIpv4 } from 'public-ip';
  import controller from '@/controller';
  import lodash from 'lodash';
  import CustomerCountryMixin from '../views/Mixins/CustomerCountryMixin.vue';
  import MobileMixin from '../views/Mixins/MobileMixin.vue';
  import CustomerStatusMixin from '../views/Mixins/CustomerStatusMixin.vue';
  import * as config from '@/config';
  import Spinner from './Loading/Spinner.vue';

  export default {
    name: 'black-friday-alert',
    props: {
      isVisible: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      Spinner,
    },
    computed: {
      ...mapGetters({
        currentUser: 'getCurrentUser',
        userProfile: 'getUserProfile',
        parentUserProfile: 'getParentUserProfile',
      }),
      ...mapState(['isPaddleReady']),
      planNameToDisplay() {
        if (this.planName === 'premium') {
          return 'Creator';
        }
        if (this.planName === 'standard') {
          return 'Starter';
        }

        return this.planName;
      },
      isStripeCustomer() {
        return lodash.get(this, 'parentUserProfile.isStripeCustomer', false);
      },
      blackFridayCustomerStatus() {
        return this.parentUserProfile.customerStatus;
      },
      computedPlanName() {
        switch (this.blackFridayCustomerStatus) {
          case 'none':
            return 'basic';
          case 'basic':
            return 'starter';
          case 'standard':
          case 'premium':
            return 'creator';
          default:
            return '';
        }
      },
      VATPrice() {
        switch (this.blackFridayCustomerStatus) {
          case 'none':
            return this.basicYearly.tax;
          case 'basic':
            return this.standardYearly.tax;
          case 'standard':
          case 'premium':
            return this.premiumYearly.tax;
          default:
            return '';
        }
      },
      isUserMonthly() {
        const subscriptionInterval = lodash.get(this.parentUserProfile, 'subscriptionInterval');
        return subscriptionInterval === 'month';
      },
      priceLabel() {
        switch (this.blackFridayCustomerStatus) {
          case 'none':
            return `${this.basicYearly.newPrice.toFixed(0)}${this.basicYearly.currency}/year`;
          case 'standard':
          case 'premium':
            return `${this.premiumYearly.newPrice.toFixed(0)}${this.premiumYearly.currency}/year`;
          default:
            return '';
        }
      },
      discountPercentage() {
        switch (this.blackFridayCustomerStatus) {
          case 'standard':
          case 'premium':
            return 40;
          default:
            return '';
        }
      },
      scheduleLimit() {
        switch (this.blackFridayCustomerStatus) {
          case 'none':
          case 'basic':
            return 1;
          case 'standard':
          case 'premium':
            return 3;
          default:
            return '';
        }
      },
      connectedAccountsLimit() {
        switch (this.blackFridayCustomerStatus) {
          case 'none':
          case 'basic':
            return 1;
          case 'standard':
          case 'premium':
            return 5;
          default:
            return '';
        }
      },
      autoDmsLimit() {
        switch (this.blackFridayCustomerStatus) {
          case 'none':
          case 'basic':
            return 0;
          case 'standard':
          case 'premium':
            return 250;
          default:
            return '';
        }
      },
      engagementLimit() {
        switch (this.blackFridayCustomerStatus) {
          case 'none':
          case 'basic':
            return {
              users: 0,
              keywords: 0,
            };
          case 'standard':
          case 'premium':
            return {
              users: 100,
              keywords: 10,
            };
          default:
            return {
              users: 30,
              keywords: 5,
            };
        }
      },
      planNameForCheckout() {
        if (['premium', 'trial', 'standard'].includes(this.blackFridayCustomerStatus))
          return 'premium';

        if (this.blackFridayCustomerStatus === 'none') return 'basic';

        return this.blackFridayCustomerStatus;
      },
    },

    data() {
      return {
        customerIp: '',
        step: 0,
        wasClosed: false,
        isUpgrading: false,
        pricesLoaded: false,
        premiumYearly: {},
        standardYearly: {},
        basicYearly: {},
        agencyYearly: {},
        businessYearly: {},
        planName: '',
        discount: null,
      };
    },
    methods: {
      capitalize: lodash.capitalize,
      close() {
        this.step = 0;
        this.$emit('close');
      },
      showNextStep(planName) {
        this.step += 1;
        this.planName = planName;
      },
      async upgradeUserToYearly() {
        this.isUpgrading = true;

        try {
          await controller.upgradeUserToYearlyBlackFriday(
            this.currentUser,
            lodash.capitalize(this.planName),
            this.customerIp,
          );

          this.$notify({
            type: 'success',
            message: `You have successfully upgraded to ${lodash.capitalize(
              this.planName,
            )} Yearly plan!`,
          });
        } catch {
          this.swalModal({
            title: 'Sorry',
            text: `An error has occurred while trying to upgrade you to the Yearly plan.`,
            type: 'warning',
          });
        } finally {
          this.isUpgrading = false;
          this.close();
        }
      },
      getProductId(plan) {
        return config.paddleInfo.plans[`${plan}Yearly`];
      },
      async checkout(plan) {
        const camelCasePlan = plan
          .toLowerCase()
          .split(' ')
          .map((word, index) => (index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)))
          .join('');
        const product = this.getProductId(camelCasePlan);

        let coupon;
        if (camelCasePlan.toLowerCase().includes('premium')) {
          coupon = 'BLACKFRIDAY2025PR';
        } else if (camelCasePlan.toLowerCase().includes('standard')) {
          coupon = 'BLACKFRIDAY2025ST';
        }

        const theme = localStorage.getItem('theme');
        window.Paddle.Checkout.open({
          country: this.countryCode,
          email: this.parentUserProfile.email,
          product,
          passthrough: JSON.stringify({ userId: this.parentUserProfile.uid }),
          displayModeTheme: !['dark', 'light'].includes(theme) ? 'light' : theme,
          ...(coupon ? { coupon } : {}),
        });

        this.close();
      },
      loadPaddle() {
        if (!window.Paddle) return;
        if (!config.isEnvProd) {
          window.Paddle.Environment.set('sandbox');
        }

        window.Paddle.Setup({
          vendor: config.paddleInfo.vendorId,
          eventCallback: async (data) => {
            const eventData = data.eventData;
            if (data.event === 'Checkout.PaymentComplete') {
              // First promoter integration
              window.fpr &&
                window.fpr('referral', {
                  email: eventData.user.email,
                  uid: eventData.user.id,
                });
            }

            if (data.event === 'Checkout.Coupon.Applied') {
              const coupon = eventData.coupon.coupon_code;
              const intervalCoupon = this.intervalCoupons[coupon];
              if (intervalCoupon) {
                const months = intervalCoupon.durationInMonths;
                const monthsText = months === 1 ? 'month' : 'months';
                this.$notify({
                  type: 'success',
                  message: `Your coupon has been applied successfully and it will be valid for ${months} ${monthsText}!`,
                });
              }
            }

            if (data.event === 'Checkout.Complete') {
              window.dataLayer = window.dataLayer || [];
              controller.setBlackFridayOfferTaken(this.currentUser, this.currentUser.uid);
              this.close();

              // eslint-disable-next-line no-inner-declarations, prettier/prettier, no-undef
              function gtag(){dataLayer.push(arguments)};
              gtag('event', 'purchase', {
                transaction_id: data.eventData.checkout.id,
                value: data.eventData.checkout.prices.customer.total,
                currency: data.eventData.checkout.prices.customer.currency,
              });
            }
          },
        });
      },
    },
    async mounted() {
      await this.getCustomerCountry();
      this.customerIp = await publicIpv4();
      const planPrices = await controller.getPlansPrices(this.currentUser, this.customerIp);
      const yearlyPlans = planPrices.filter((plan) => plan.subscription.interval === 'year');

      const standardYearly = yearlyPlans.find((plan) =>
        plan.product_title.toLowerCase().includes('standard'),
      );

      this.standardYearly.currency = standardYearly.currency;
      this.standardYearly.gross = standardYearly.price.gross;
      this.standardYearly.net = standardYearly.price.net;
      this.$set(this.standardYearly, 'tax', standardYearly.price.tax);

      // 20% discount
      this.standardYearly.newPrice = standardYearly.price.net * 0.8;

      const premiumYearly = yearlyPlans.find((plan) =>
        plan.product_title.toLowerCase().includes('premium'),
      );

      this.premiumYearly.currency = premiumYearly.currency;
      this.premiumYearly.gross = premiumYearly.price.gross;
      this.premiumYearly.net = premiumYearly.price.net;
      this.$set(this.premiumYearly, 'tax', premiumYearly.price.tax);
      // 40% discount
      this.premiumYearly.newPrice = premiumYearly.price.net * 0.6;

      const basicYearly = yearlyPlans.find((plan) =>
        plan.product_title.toLowerCase().includes('basic'),
      );
      this.basicYearly.currency = basicYearly.currency;
      this.basicYearly.gross = basicYearly.price.gross;
      this.basicYearly.net = basicYearly.price.net;
      this.$set(this.basicYearly, 'tax', basicYearly.price.tax);
      this.basicYearly.newPrice = basicYearly.price.net;

      this.pricesLoaded = true;
    },
    mixins: [SwalModalMixin, CustomerCountryMixin, MobileMixin, CustomerStatusMixin],
    watch: {
      isPaddleReady: {
        immediate: true,
        handler(val) {
          if (val) {
            this.loadPaddle();
          }
        },
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mode--light {
    .bulletpoint-bg {
      background-color: black;
    }

    .icon {
      stroke: #0078fb;
    }
  }

  .mode--dark {
    .bulletpoint-bg {
      background-color: white;
    }

    .icon {
      stroke: white;
    }
  }
</style>
